// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ProviderLetterAddress,
    ProviderLetterAddressFromJSON,
    ProviderLetterAddressToJSON,
    ProviderLetterTrackingEvent,
    ProviderLetterTrackingEventFromJSON,
    ProviderLetterTrackingEventToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderLetterResponse
 */
export interface ProviderLetterResponse {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderLetterResponse
     */
    id?: string;
    /**
     * 
     * OpenAPI data type: {ProviderLetterAddress}
     * @type {ProviderLetterAddress}
     * @memberof ProviderLetterResponse
     */
    to?: ProviderLetterAddress;
    /**
     * 
     * OpenAPI data type: {ProviderLetterAddress}
     * @type {ProviderLetterAddress}
     * @memberof ProviderLetterResponse
     */
    from?: ProviderLetterAddress;
    /**
     * 
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderLetterResponse
     */
    color?: boolean;
    /**
     * 
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderLetterResponse
     */
    doubleSided?: boolean;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderLetterResponse
     */
    addressPlacement?: string;
    /**
     * 
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderLetterResponse
     */
    returnEnvelope?: boolean;
    /**
     * 
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof ProviderLetterResponse
     */
    perforatedPage?: number;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderLetterResponse
     */
    extraService?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderLetterResponse
     */
    mailType?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderLetterResponse
     */
    url?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderLetterResponse
     */
    expectedDeliveryDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderLetterResponse
     */
    sendDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderLetterResponse
     */
    carrier?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderLetterResponse
     */
    trackingNumber?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderLetterTrackingEvent>}
     * @memberof ProviderLetterResponse
     */
    trackingEvents?: Array<ProviderLetterTrackingEvent>;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderLetterResponse
     */
    description?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderLetterResponse
     */
    dateCreated?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderLetterResponse
     */
    dateModified?: string;
    /**
     * 
     * OpenAPI data type: {object}
     * @type {object}
     * @memberof ProviderLetterResponse
     */
    metadata?: object;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderLetterResponse
     */
    object?: string;
}

export function ProviderLetterResponseFromJSON(json: any): ProviderLetterResponse {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'to': !exists(json, 'to') ? undefined : ProviderLetterAddressFromJSON(json['to']),
            'from': !exists(json, 'from') ? undefined : ProviderLetterAddressFromJSON(json['from']),
            'color': !exists(json, 'color') ? undefined : json['color'],
            'doubleSided': !exists(json, 'doubleSided') ? undefined : json['doubleSided'],
            'addressPlacement': !exists(json, 'addressPlacement') ? undefined : json['addressPlacement'],
            'returnEnvelope': !exists(json, 'returnEnvelope') ? undefined : json['returnEnvelope'],
            'perforatedPage': !exists(json, 'perforatedPage') ? undefined : json['perforatedPage'],
            'extraService': !exists(json, 'extraService') ? undefined : json['extraService'],
            'mailType': !exists(json, 'mailType') ? undefined : json['mailType'],
            'url': !exists(json, 'url') ? undefined : json['url'],
            'expectedDeliveryDate': !exists(json, 'expectedDeliveryDate') ? undefined : json['expectedDeliveryDate'],
            'sendDate': !exists(json, 'sendDate') ? undefined : json['sendDate'],
            'carrier': !exists(json, 'carrier') ? undefined : json['carrier'],
            'trackingNumber': !exists(json, 'trackingNumber') ? undefined : json['trackingNumber'],
            'trackingEvents': !exists(json, 'trackingEvents') ? undefined : (json['trackingEvents'] as Array<any>).map(ProviderLetterTrackingEventFromJSON),
            'description': !exists(json, 'description') ? undefined : json['description'],
            'dateCreated': !exists(json, 'dateCreated') ? undefined : json['dateCreated'],
            'dateModified': !exists(json, 'dateModified') ? undefined : json['dateModified'],
            'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
            'object': !exists(json, 'object') ? undefined : json['object'],
    };

}

export function ProviderLetterResponseToForm(value?: ProviderLetterResponse): any {
    let jsonVal = ProviderLetterResponseToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderLetterResponseToJSON(value?: ProviderLetterResponse): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'to': ProviderLetterAddressToJSON(value.to),
            'from': ProviderLetterAddressToJSON(value.from),
            'color': cleanupBlankValuesForBackend(value.color),
            'doubleSided': cleanupBlankValuesForBackend(value.doubleSided),
            'addressPlacement': cleanupBlankValuesForBackend(value.addressPlacement),
            'returnEnvelope': cleanupBlankValuesForBackend(value.returnEnvelope),
            'perforatedPage': cleanupBlankValuesForBackend(value.perforatedPage),
            'extraService': cleanupBlankValuesForBackend(value.extraService),
            'mailType': cleanupBlankValuesForBackend(value.mailType),
            'url': cleanupBlankValuesForBackend(value.url),
            'expectedDeliveryDate': cleanupBlankValuesForBackend(value.expectedDeliveryDate),
            'sendDate': cleanupBlankValuesForBackend(value.sendDate),
            'carrier': cleanupBlankValuesForBackend(value.carrier),
            'trackingNumber': cleanupBlankValuesForBackend(value.trackingNumber),
            'trackingEvents': (value.trackingEvents === undefined || value.trackingEvents === null) ? undefined : (value.trackingEvents as Array<any>).map(ProviderLetterTrackingEventToJSON),
            'description': cleanupBlankValuesForBackend(value.description),
            'dateCreated': cleanupBlankValuesForBackend(value.dateCreated),
            'dateModified': cleanupBlankValuesForBackend(value.dateModified),
            'metadata': cleanupBlankValuesForBackend(value.metadata),
            'object': cleanupBlankValuesForBackend(value.object),
    };
}


